import { render } from "./servicesUpdated.vue?vue&type=template&id=6e6ae0c8&scoped=true"
import script from "./servicesUpdated.vue?vue&type=script&lang=js"
export * from "./servicesUpdated.vue?vue&type=script&lang=js"

import "./servicesUpdated.vue?vue&type=style&index=0&id=6e6ae0c8&scoped=true&lang=css"

import exportComponent from "C:\\Users\\amaan\\encanto-new\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e6ae0c8"]])

export default __exports__